const footerEN = {
	tagline: "The simplest way to book — and to be booked. Built in the Dominican Republic for the businesses that keep it moving.",
	columns: {
		company: "Company",
		legal: "Legal",
		getApp: "Get the app",
	},
	links: {
		about: "About Us",
		privacy: "Privacy Policy",
		terms: "Terms of Service",
		contact: "Contact",
		refundPolicy: "Refund Policy",
	},
	apps: {
		note: "iOS and Android apps are on the way.",
		soon: "Soon",
		appStoreAria: "Download on the App Store",
		appStoreSmall: "Download on the",
		appStoreName: "App Store",
		googlePlayAria: "Get it on Google Play",
		googlePlaySmall: "Get it on",
		googlePlayName: "Google Play",
	},
	/* Shared chrome for the long-form legal pages */
	legal: {
		eyebrow: "Legal",
		contents: "Contents",
		backToTop: "Back to top",
	},
	socialsLabel: "Follow Sin Fila",
	languageSwitch: "Español",
	madeInDR: "Proudly built and registered in the Dominican Republic",
	rights: "All rights reserved.",
};

export default footerEN;
